import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { IPanel, Panel, PanelPropertyValues } from "./Panel";
import { NAMESPACE } from "./_Namespace";

import "./DetailsPageRelatedRecordsPanel.scss";

export type DetailsPageRelatedRecordsPanelPropertyValues =
    PanelPropertyValues
    & {
    };

export type DetailsPageRelatedRecordsPanelProperties = {
    [name in keyof DetailsPageRelatedRecordsPanelPropertyValues]: Property<DetailsPageRelatedRecordsPanelPropertyValues[name]>
};

export interface IDetailsPageRelatedRecordsPanel extends IPanel, DetailsPageRelatedRecordsPanelProperties
{
}

export class DetailsPageRelatedRecordsPanel extends Panel implements IDetailsPageRelatedRecordsPanel
{
    public static override classNamespace = NAMESPACE + "DetailsPageRelatedRecordsPanel";
    public static override className = "DetailsPageRelatedRecordsPanel";

    // #region Constructor

    constructor(propertyValues?: PartialNullable<DetailsPageRelatedRecordsPanelPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-details-page-related-records-panel");
    }

    // #endregion
}

